import { makeActionCreator } from '../../../utilities'
import { TripInformationConstants } from './tripInformation.constants'

export const setBase = makeActionCreator(TripInformationConstants.SET_BASE, 'base')
export const setUnit = makeActionCreator(TripInformationConstants.SET_UNIT, 'unit')
export const setStaffingLevel = makeActionCreator(TripInformationConstants.SET_STAFFING_LEVEL, 'staffingLevel')
export const setUnitEquipment = makeActionCreator(TripInformationConstants.SET_UNIT_EQUIPMENT, 'unitEquipment')
export const setShift = makeActionCreator(TripInformationConstants.SET_SHIFT, 'shift')
export const setDispatchID = makeActionCreator(TripInformationConstants.SET_DISPATCH_ID, 'dispatchID')
export const setLocalId = makeActionCreator(TripInformationConstants.SET_LOCAL_ID, 'localId')
export const setRegistrationTailNumber = makeActionCreator(
  TripInformationConstants.SET_REGISTRATION_TAIL_NUMBER,
  'registrationTailNumber'
)
export const setDispatchPriority = makeActionCreator(TripInformationConstants.SET_DISPATCH_PRIORITY, 'dispatchPriority')
export const setEmdPerformed = makeActionCreator(TripInformationConstants.SET_EMD_PERFORMED, 'emdPerformed')
export const setEmdPerformedPNNV = makeActionCreator(
  TripInformationConstants.SET_EMD_PERFORMED_PNNV,
  'emdPerformedPNNV'
)
export const setEmd = makeActionCreator(TripInformationConstants.SET_EMD, 'emd')
export const setTypeofService = makeActionCreator(TripInformationConstants.SET_TYPE_OF_SERVICE, 'typeofService')
export const setScheduled = makeActionCreator(TripInformationConstants.SET_SCHEDULED, 'scheduled')
export const setStandbyPurpose = makeActionCreator(TripInformationConstants.SET_STANDBY_PURPOSE, 'standByPurpose')
export const setCallType = makeActionCreator(TripInformationConstants.SET_CALL_TYPE, 'callType')
export const setPatientCategory = makeActionCreator(TripInformationConstants.SET_PATIENT_CATEGORY, 'patientCategory')

export const setDispatchedAs = makeActionCreator(TripInformationConstants.SET_DISPATCHED_AS, 'dispatchedAs')

export const setDisposition = makeActionCreator(TripInformationConstants.SET_DISPOSITION, 'disposition')
export const setUnitDisposition = makeActionCreator(TripInformationConstants.SET_UNIT_DISPOSITION, 'unitDisposition')
export const setPatientEvaluation = makeActionCreator(
  TripInformationConstants.SET_PATIENT_EVALUATION,
  'patientEvaluation'
)
export const setPatientEvaluationPNNV = makeActionCreator(
  TripInformationConstants.SET_PATIENT_EVALUATION_PNNV,
  'patientEvaluationPNNV'
)
export const setCrewDisposition = makeActionCreator(TripInformationConstants.SET_CREW_DISPOSITION, 'crewDisposition')
export const setCrewDispositionPNNV = makeActionCreator(
  TripInformationConstants.SET_CREW_DISPOSITION_PNNV,
  'crewDispositionPNNV'
)
export const setTransportDisposition = makeActionCreator(
  TripInformationConstants.SET_TRANSPORT_DISPOSITION,
  'transportDisposition'
)
export const setTransportDispositionPNNV = makeActionCreator(
  TripInformationConstants.SET_TRANSPORT_DISPOSITION_PNNV,
  'transportDispositionPNNV'
)
export const setRefusalReleaseReason = makeActionCreator(
  TripInformationConstants.SET_REFUSAL_RELEASE_REASON,
  'refusalReleaseReason'
)

export const setAmbulanceTransportCode = makeActionCreator(
  TripInformationConstants.SET_AMBULANCE_TRANSPORT_CODE,
  'ambulanceTransportCode'
)
export const setMassCasualty = makeActionCreator(TripInformationConstants.SET_MASS_CASUALTY, 'massCasualty')
export const setMassCasualtyPNNV = makeActionCreator(
  TripInformationConstants.SET_MASS_CASUALTY_PNNV,
  'massCasualtyPNNV'
)
export const setDispatchLocation = makeActionCreator(TripInformationConstants.SET_DISPATCH_LOCATION, 'dispatchLocation')
export const setVehicleGPSN = makeActionCreator(TripInformationConstants.SET_VEHICLE_GPS_N, 'vehicleGPSN')
export const setVehicleGPSE = makeActionCreator(TripInformationConstants.SET_VEHICLE_GPS_E, 'vehicleGPSE')
export const setVehicleUSNG = makeActionCreator(TripInformationConstants.SET_VEHICLE_USNG, 'vehicleUSNG')
export const setVehicleGrid = makeActionCreator(TripInformationConstants.SET_VEHICLE_GRID, 'vehicleGrid')
export const setAPIResponse = makeActionCreator(TripInformationConstants.SET_API_RESPONSE, 'apiResponse')
export const saveTripInformation = makeActionCreator(TripInformationConstants.SAVE_TRIP_INFORMATION)
export const setTripInformation = makeActionCreator(TripInformationConstants.SET_TRIP_INFORMATION, 'tripInformation')
export const resetTripInformationState = makeActionCreator(TripInformationConstants.RESET_TRIP_INFORMATION)
export const calculateVehicleUsng = makeActionCreator(TripInformationConstants.CALCULATE_VEHICLE_USNG)
export const setVehicleMileageStart = makeActionCreator(
  TripInformationConstants.SET_VEHICLE_MILEAGE_START,
  'vehicleMileageStart'
)
export const setVehicleMileageRef = makeActionCreator(
  TripInformationConstants.SET_VEHICLE_MILEAGE_REF,
  'vehicleMileageRef'
)
export const setVehicleMileageEnd = makeActionCreator(
  TripInformationConstants.SET_VEHICLE_MILEAGE_END,
  'vehicleMileageEnd'
)
export const setVehicleMileageRec = makeActionCreator(
  TripInformationConstants.SET_VEHICLE_MILEAGE_REC,
  'vehicleMileageRec'
)
export const setVehicleMileageLoaded = makeActionCreator(
  TripInformationConstants.SET_VEHICLE_MILEAGE_LOADED,
  'vehicleMileageLoaded'
)
export const setVehicleMileageTotal = makeActionCreator(
  TripInformationConstants.SET_VEHICLE_MILEAGE_TOTAL,
  'vehicleMileageTotal'
)
export const setTeam = makeActionCreator(TripInformationConstants.SET_TEAM, 'team')
export const setTeamCareOnly = makeActionCreator(TripInformationConstants.SET_TEAM_CARE_ONLY, 'teamCareOnly')
export const setEquipment = makeActionCreator(TripInformationConstants.SET_EQUIPMENT, 'equipment')
export const setProviderRoles = makeActionCreator(TripInformationConstants.SET_PROVIDER_ROLES, 'providerRoles')
export const setMaxAlt = makeActionCreator(TripInformationConstants.SET_MAX_ALT, 'maxAlt')
export const setFlightPlan = makeActionCreator(TripInformationConstants.SET_FLIGHT_PLAN, 'flightPlan')
export const setVehicleMileageLpm = makeActionCreator(TripInformationConstants.SET_VEHICLE_MILEAGE_LPM, 'lpm_lpm')
export const setVehicleMileageOdom = makeActionCreator(TripInformationConstants.SET_VEHICLE_MILEAGE_ODOM, 'lpm_odom')
export const CalculateVehicleMileageLoaded = makeActionCreator(
  TripInformationConstants.CALCULATE_VEHICLE_MILEAGE_LOADED
)
export const CalculateVehicleMileageTotal = makeActionCreator(TripInformationConstants.CALCULATE_VEHICLE_MILEAGE_TOTAL)
export const setUnitOption = makeActionCreator(TripInformationConstants.SET_UNIT_OPTION, '__unitOption')
export const setBaseOption = makeActionCreator(TripInformationConstants.SET_BASE_OPTION, '__baseOption')
export const setRegTailNumberOption = makeActionCreator(
  TripInformationConstants.SET_REG_TAIL_NUMBER_OPTION,
  '__regTailNumberOption'
)
